<template>
  <footer qaid="project-one-right-rail-footer" class="project-one-right-rail-footer">
    <trek-button
      qaid="project-one-right-rail-footer-button"
      class="project-one-right-rail-footer__button"
      :primary="isPrimaryButton"
      :secondary="buttonSecondary"
      :icon-right="isIconRight"
      :icon-left="buttonIconLeft"
      block
      :icon="buttonIcon || buttonDefaults.icon"
      v-on="buttonAction ? {click: buttonAction} : {}"
    >
      <span v-html="buttonText" />
    </trek-button>
  </footer>
</template>

<script>
import TrekButton from '@/components/TrekButton.vue';

export default {
  components: {TrekButton},

  props: {
    buttonText: {
      type: String,
      default: null,
    },
    buttonSecondary: {
      type: Boolean,
      default: false,
    },
    buttonIconRight: {
      type: Boolean,
      default: false,
    },
    buttonIconLeft: {
      type: Boolean,
      default: false,
    },
    buttonIcon: {
      type: String,
      default: null,
    },
    buttonAction: {
      type: Function,
      default: null,
    },
  },

  data() {
    return {
      buttonDefaults: {
        primary: true,
        icon: 'arrow_forward',
        iconRight: true,
      },
    };
  },

  computed: {
    isPrimaryButton() {
      if (this.buttonPrimary) {
        return true;
      } else if (this.buttonSecondary) {
        return false;
      } else {
        return this.buttonDefaults.primary;
      }
    },

    isIconRight() {
      if (this.buttonIconRight) {
        return true;
      } else if (this.buttonIconLeft) {
        return false;
      } else {
        return this.buttonDefaults.iconRight;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.project-one-right-rail-footer {
  @apply px-4;
  @apply py-3;

  text-align: center;

  &__button {
    @apply max-w-sm;
    @apply mx-auto;

    @include breakpoint(large) {
      @apply max-w-none;
    }
  }
}
</style>
